import { propOr, prop, assoc } from 'ramda'

import moment from 'utils/moment'

export const NUMBER_12 = 12
export const MONTH = 30
export const START_DATE = moment().subtract(MONTH, 'day').format('DD.MM.YYYY')
export const END_DATE = moment().format('DD.MM.YYYY')

export const getFilters = query => {
  const page = Number(propOr(1, 'page', query))
  const type = propOr('', 'TYPE', query)
  const viewed = propOr('', 'VIEWED', query)
  const sort = prop('sort', query)
  const order = prop('order', query)
  const limit = parseInt(propOr(NUMBER_12, 'limit', query), 10)
  const startDate = propOr(START_DATE, 'startDate', query)
  const endDate = propOr(END_DATE, 'endDate', query)
  let filter = {
    'filter[DATE_FROM]': moment(startDate, 'DD.MM.YYYY').startOf('day').unix(),
    'filter[DATE_TO]': moment(endDate, 'DD.MM.YYYY').endOf('day').unix()
  }
  if (type) {
    filter = assoc('filter[TYPE]', type, filter)
  }
  if (viewed) {
    filter = assoc('filter[VIEWED]', viewed, filter)
  }
  const offset = (page - 1)* limit
  return {
    page,
    limit,
    offset,
    sort,
    order,
    filter
  }
}